<!--
* @description  参数1
* @fileName  ByTable
* @author userName
* @date 2021-11-16 15:06:56
!-->
<template>
  <div id="ByTable" class="ByTable">
    <table border="0" cellspacing="0" cellpadding="0" class="by-table-box" width="100%">
      <thead>
        <slot name="byThead"></slot>
      </thead>
    </table>
    <div v-if="tableList.length>0">
      <div v-for="(itemList, indexList) in tableList" :key="indexList">
        <table border="0" cellspacing="0" cellpadding="0" class="by-table-box mar_T_10 " width="100%" align="center">
          <tbody>
            <slot name="byTbody" :listTable="itemList" :listTableIdx="indexList"></slot>
          </tbody>
        </table>
        <div class="mr_lr_10 by-bor-item " :style="{background:colorBg}">
          <slot :listTable="itemList" :listTableIdx="indexList"></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    // 父辈向子辈传参
    tableList: {
      type: [Array],
      default: () => [],
    },
    colorBg: {
      type: [String],
      default: '#f9f9f9',
    }
  },
  name: "ByTable",
  data() {
    return {
    };
  },
  created() {
    // 实例被创建之后执行代码
  },
  computed: {
    // 计算属性
  },
  components: {
    // 组件的引用
  },
  methods: {
    // 方法
  },
  mounted() {
    // 页面进入时加载内容
  },
  watch: {
    // 监测变化
  },
};
</script>
<style scoped lang='scss'>
.fff {
  background: #fff;
}
.pd_tb_12 {
  padding: 12px 0;
}
.pd_lr_6 {
  padding: 0 6px;
}
.mr_lr_10 {
  margin: 0 10px;
}
.bor_ddd_03 {
  border-left: 1px solid rgba($color: #dddddd, $alpha: 0.3);
}
.mar_T_10 {
  margin-top: 10px;
}
.by-table-box {
  background: #f9f9f9;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.16);
  border-radius: 10px;
}
.by-bor-item {
  border: 1px solid rgba($color: #d8d8d8, $alpha: 1);
  border-top: 0;
  border-radius: 0px 0px 10px 10px;
  overflow: hidden;
}

.table-title {
  // overflow: hidden;
  box-sizing: border-box;
  word-break: break-all;
}
</style>


// WEBPACK FOOTER //
// src/common/components/ByTable.vue